<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Candal&family=Kalam:wght@300;400;700&display=swap"
  rel="stylesheet">



<div style="display:flex; flex-direction: column; justify-content: space-between;">

  <br>
  <br>

  <h1 style="margin: auto;">Tutor</h1>

  <br>
  <br>

  <div class="form-wrapper">

    <form [formGroup]="searchForm" id="frm">

      <mat-form-field class="cpf-width">
        <input required matInput type="text" [errorStateMatcher]="matcher" [formControl]="searchForm.controls.cpf"
          placeholder="Nº documento" autocomplete="off">
        <mat-error *ngIf="searchForm.controls.cpf.hasError('required')">
          Nº documento é obrigatório
        </mat-error>
      </mat-form-field>

    </form>

    <button mat-raised-button (click)='tutorGetMemberSituation()' [disabled]="searchForm.invalid">
      <span>CONSULTAR</span>
    </button>

  </div>

  <br>
  <br>
  
  <div [ngClass]="{hidden: !spinner}">
    <mat-spinner diameter="30"></mat-spinner>
  </div>

  <div style="margin: auto;">
    <div *ngIf="errorMessage" style = "color: red;">{{errorMessage}}</div>
    <div *ngIf="cpf">cpf: {{cpf}}</div>
    <div *ngIf="member">member: {{member}}</div>
    <div *ngIf="category">category: {{category}}</div>
    <div *ngIf="situation">situation: {{situation}}</div>
  </div>
</div>